/* eslint-disable import/prefer-default-export */
import ReactGA from 'react-ga4';

export const captureGAEvent = gaEvent => {
  ReactGA.event(gaEvent);
};
